import React, { useEffect } from 'react';

import { useAppDispatch, useAppSelector } from '~redux/hooks';
import combinedActions from '~redux/combinedActions';
import Modal from '~components/atoms/Modal';
import BranchBaseForm from '../BranchesBaseForm';

import { TCreateNewBranchReduxParams } from '~types/feat/branch';

const BranchesCreateNewBranchModal = () => {
    const dispatch = useAppDispatch();

    const isOpen = useAppSelector(state => state.branch.modals.createNewBranchModalIsOpen);
    const isLoading = useAppSelector(state => state.branch.loadings.createNewBranch);
    const error = useAppSelector(state => state.branch.errors.createNewBranch);

    const handleModalOnClose = () => {
        dispatch(combinedActions.branchResetCreateNewBranchState());
        dispatch(combinedActions.branchSetCreateNewBranchModalIsOpen(false));
    };

    const handleOnSubmit = (data: TCreateNewBranchReduxParams) => !isLoading && dispatch(combinedActions.branchCreateNewBranchAttempt(data));

    return (
        <Modal
            title='Create Branch'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            <BranchBaseForm
                submitButtonLabel='Create Branch'
                onSubmit={handleOnSubmit}
                actionButtonIsLoading={isLoading}
                error={error}
            />
        </Modal>
    );
};

export default BranchesCreateNewBranchModal;
